import { z } from "zod";

export const UserSettingsSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string().nullable(),
  timezone: z.string(),
  wakeTargetTime: z.string().nullable(),
  sleepTargetTime: z.string().nullable(),
  deepWorkTargetMinutes: z.number().int().nonnegative(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const CurrentUserResponseSchema = z.object({
  user: UserSettingsSchema,
});

export const PatchCurrentUserSchema = z
  .object({
    name: z.string().trim().min(1).max(80).optional(),
    timezone: z.string().min(1).max(64).optional(),
    wakeTargetTime: z.string().nullable().optional(),
    sleepTargetTime: z.string().nullable().optional(),
    deepWorkTargetMinutes: z.number().int().min(0).max(600).optional(),
  })
  .refine((value) => Object.keys(value).length > 0, {
    message: "At least one field is required.",
  });

export type UserSettings = z.infer<typeof UserSettingsSchema>;
export type CurrentUserResponse = z.infer<typeof CurrentUserResponseSchema>;
export type PatchCurrentUserInput = z.infer<typeof PatchCurrentUserSchema>;
